import React from "react";
import { Lock, FileText } from "lucide-react";
import { fmtWhen, fmtUsd } from "./labels";

const ROLE = {
  traveler: { side: "justify-start", bubble: "bg-white border-clay-300", who: "Viajero" },
  agent: { side: "justify-end", bubble: "bg-clay-900 text-white border-clay-900", who: "Nosotros" },
  kimkim: { side: "justify-center", bubble: "bg-amber-50 border-amber-200 text-amber-900 text-xs", who: "KimKim" },
  system: { side: "justify-center", bubble: "bg-clay-100 border-clay-200 text-clay-700 text-xs", who: "Sistema" },
};

export function ChatReader({ messages, proposals = [] }) {
  if (!messages?.length) return <div className="border border-dashed border-clay-300 p-8 text-center text-sm text-clay-600" data-testid="kimkim-chat-empty">Sin mensajes guardados para este lead.</div>;
  let lastDay = null;
  return (
    <div className="border border-clay-300 bg-clay-50 p-4 space-y-3 max-h-[70vh] overflow-y-auto" data-testid="kimkim-chat">
      {messages.map((m, i) => {
        const r = ROLE[m.role] || ROLE.system;
        const day = m.at ? new Date(m.at).toLocaleDateString("es-ES", { weekday: "short", day: "2-digit", month: "short", year: "numeric" }) : null;
        const showDay = day && day !== lastDay;
        lastDay = day || lastDay;
        const props = m.at ? proposals.filter((p) => p.sent_at === m.at) : [];
        return (
          <React.Fragment key={i}>
            {showDay && <div className="text-center text-[10px] uppercase tracking-wider text-clay-500 pt-2">{day}</div>}
            <div className={`flex ${r.side}`}>
              <div className={`max-w-[78%] border px-3 py-2 text-sm whitespace-pre-wrap ${r.bubble}`} data-testid={`kimkim-msg-${i}`}>
                <div className={`text-[10px] uppercase tracking-wider mb-1 flex items-center gap-1 ${m.role === "agent" ? "text-clay-300" : "text-clay-500"}`}>
                  {m.private && <Lock size={9}/>}{r.who}{m.author ? ` · ${m.author}` : ""} · {m.at ? new Date(m.at).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" }) : "—"}{m.private ? " · nota privada" : ""}
                </div>
                {m.text}
                {props.map((p) => (
                  <a key={p.url} href={p.url} target="_blank" rel="noreferrer" className={`mt-2 flex items-center gap-2 border px-2 py-1.5 text-[12px] no-underline ${m.role === "agent" ? "border-clay-600 bg-clay-800 text-white hover:border-white" : "border-clay-300 bg-clay-50 hover:border-clay-900"}`} data-testid={`kimkim-msg-${i}-proposal`}>
                    <FileText size={12} className="shrink-0"/> <span className="truncate">{p.title || "Propuesta"}</span>{p.price_usd ? <span className="ml-auto tabular whitespace-nowrap">{fmtUsd(p.price_usd)}</span> : null}
                  </a>
                ))}
              </div>
            </div>
          </React.Fragment>
        );
      })}
      <div className="text-[10px] text-clay-500 text-right">Último mensaje: {fmtWhen(messages[messages.length - 1]?.at)}</div>
    </div>
  );
}
